
import BrandOpportunities from './BrandOpportunities.vue';
import BrandAccounting from './BrandAccounting.vue';
import BrandNotes from './BrandNotes.vue';
import ActivityFeed from '@gid/vue-common/components/ActivityFeed.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
    BrandOpportunities,
    BrandAccounting,
    BrandNotes,
    ActivityFeed,
  },
  props: {
    brand: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async update() {
      this.$emit('update');
    },
  },
});
